import { useLocation, useNavigate } from "react-router-dom";

/**
 * Helper for using routes to control the contents and open state of a Drawer
 * @param route the route to navigate to on opening
 * @param routeMatch regex for how to match the route. If not set, will use route for the route match. Example: /create/\d+/?$
 */
export const useDrawerRoute = (route: string, routeMatch?: RegExp) => {
  const navigate = useNavigate();
  const location = useLocation();
  const routeMatchInner = routeMatch ?? new RegExp(`/${route}/?$`);
  const isOpen = location.pathname.match(routeMatchInner) !== null;

  const open = () => navigate(route);
  const close = () => navigate("./");

  return { isOpen, open, close };
};
